/*
TODO: remove this file if not used till 13th April 2023
*/
import { calculateTotalMeetingDuration } from "ui/pages/ZoomAttendance/ZoomAttendanceOfListing/ZoomAttendanceOfListing.helper";
import { _exporterBase } from "../_exporterBase";

const exporter_config = [
  {
    field: "customer_name",
    headerName: "Customer Name",
  },
  {
    field: "attendance",
    headerName: "Attendance",
    valueFormatter: (record) =>
      `${record.session_attended} / ${record.total_session}`,
  },
  {
    field: "total_meeting_duration",
    headerName: "Total Minutes Attended",
    valueFormatter: (record) =>
      calculateTotalMeetingDuration(record.total_meeting_duration).toString(),
  },
  {
    field: "customer_email",
    headerName: "Email",
  },
  {
    field: "customer_phone_numer",
    headerName: "Phone",
    valueFormatter: (record) =>
      record.customer_country_code + " " + record.customer_phone_numer,
  },
];

export const zoomAttendanceOfListingExporter = _exporterBase({
  responseMapFunction: (item) => {
    const obj = {};
    exporter_config.forEach((col) => {
      obj[col.headerName] = (
        col.valueFormatter ? col.valueFormatter(item) : item[col.field]
      ).toString();
    });
    return obj;
  },
  downloadedCSVFileName: "zoom listing attendance",
});
